import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/DatabaseConnect.css";

function DatabaseConnect() {
  const [databaseId, setDatabaseId] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!databaseId.trim()) {
      setError("Please enter a database ID");
      return;
    }
    // Validate database ID format (simplified)
    if (databaseId.length < 32) {
      setError("Invalid database ID format");
      return;
    }

    // Proceed to field selection
    navigate(`/fields/${databaseId}`);
  };

  return (
    <div className="database-connect">
      <h2>Connect to Your Notion Database</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="databaseId">Database ID:</label>
          <input
            type="text"
            id="databaseId"
            value={databaseId}
            onChange={(e) => setDatabaseId(e.target.value)}
            placeholder="Enter your Notion database ID"
          />
          {error && <p className="error">{error}</p>}
        </div>
        <button type="submit" className="primary-button">
          Connect
        </button>
      </form>
      <div className="help-text">
        <h3>How to find your Database ID:</h3>
        <ol>
          <li>Open your Notion database</li>
          <li>
            Copy the part of the URL after the workspace name and before any '?'
          </li>
          <li>Make sure you've shared the database with your integration</li>
        </ol>
      </div>
    </div>
  );
}

export default DatabaseConnect;
